/**
 * Есть ли сейчас сеть.
 *
 * Читаем из TanStack Query's onlineManager, а не из navigator.onLine напрямую:
 * очередь досылается по его же сигналу, и если экран будет судить о сети по
 * другому источнику, кнопки начнут расходиться с поведением очереди.
 *
 * ⚠ navigator.onLine (а значит и onlineManager по умолчанию) отвечает на вопрос
 * «есть ли хоть какое-то подключение», а не «доходит ли до сервера». В подвале
 * с одной палкой он скажет «онлайн». Поэтому это подсказка для интерфейса, а не
 * гарантия: запрос всё равно может упасть NetworkError, и обрабатывать его надо.
 */
import { useEffect, useState } from 'react'
import { onlineManager } from '@tanstack/react-query'

export function useOnline(): boolean {
  const [online, setOnline] = useState(() => onlineManager.isOnline())
  useEffect(() => onlineManager.subscribe(setOnline), [])
  return online
}
